import { Pipe, PipeTransform } from '@angular/core';
import {ENUM_ACTIONS} from '@Interfaces/index';

@Pipe({
  name: 'filterDropdown'
})
export class FilterDropdownPipe implements PipeTransform {

  transform(items: any[], action: ENUM_ACTIONS): any {
    if (!items || !action) {
      return items;
    }
    return items.filter(item => {
      if (item['validation']) {
         const currentMonth = new Date().getMonth() + 1;
         if(item['key'] == 12) {
          return currentMonth == 1;
         }else {
          return item['key'] + 1 == currentMonth;
         }
      }
      return item[action] === undefined || item[action];
    });
  }

}
